import React, { useEffect, useState } from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip
} from "@mui/material"
import Input from "../../components/Input"
import { useAlert } from "../../hooks/useAlert"
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"
import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"
import { LoadingButton } from "@mui/lab"
import "./Refaccion.css"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { useMessages } from "../../hooks/useMessages"
import AutocompleteDeluxe from "../../components/AutocompleteDelux"
import Servo from "../../services/servo"
import { useLocalStorage } from "../../hooks/useLocalStorage"

const Refacciones = ({
  reloadRefacciones,
  id,
  empresa,
  setProductosOrdenCompra,
  irAOrdenCompra
}) => {
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("")
  const { showAlert } = useAlert()
  const { setMessages } = useMessages()
  const [permiso] = useLocalStorage("permiso", {})
  const history = useHistory()
  const [producto, setProducto] = useState(null)
  const [sucursal, setSucursal] = useState(null)
  const [refacciones, setRefacciones] = useState([])
  const [loadingB, setLoadingB] = useState(false)
  const [solicitudes, setSolicitudes] = useState([])
  const [entregaModal, setEntregaModal] = useState({
    open: false,
    detalle: null,
    cantidad: ""
  })
  const puedeAlmacen = Number(permiso?.inventarios || 0) > 0
  const cargarSolicitudes = async () => {
    if (!id) return
    const res = await Servo.get(`inventario-ordenes?idOrdenServicio=${id}`)
    if (Array.isArray(res?.cuerpo?.resultado)) {
      setSolicitudes(res.cuerpo.resultado)
    }
  }

  useEffect(() => {
    cargarSolicitudes()
  }, [id])

  const handleCategoriaChange = (e) => {
    setCategoriaSeleccionada(e.target.value)
    setProducto(null)
  }

  const changeCantidad = async (_cantidad, pos) => {
    //validacion de productoinventario >  _cantidad && _cantidad > 0
    if ((_cantidad && _cantidad > 0) || _cantidad === "") {
      let copyData = [...refacciones]
      copyData[pos].cantidad = _cantidad
      setRefacciones([...copyData])
    }
  }

  const agregado = () => {
    if (producto == null) {
      showAlert({
        message: "Campo de Producto Vacío",
        severity: "warning"
      })
      return
    }

    let copyProductos = [...refacciones]
    let validacion = refacciones.some((product) => {
      return product.idProducto === producto.idProducto
    })

    if (validacion) {
      showAlert({
        message: "producto repetido",
        severity: "warning"
      })
      return
    }

    copyProductos.push({ ...producto, cantidad: 1 })
    setRefacciones([...copyProductos])
    setProducto(null)
  }

  const addProducto = () => {
    agregado()
  }

  const deleteProduct = (id) => {
    let arr = [...refacciones]
    refacciones.map((product, i) => {
      if (product.idProducto == id) {
        arr.splice(i, 1)
      }
    })
    setRefacciones([...arr])
    showAlert({
      message: "Producto eliminado",
      severity: "success"
    })
  }

  const guardarRefaccionesOrdenServicio = async () => {
    setLoadingB(true)
    if (!refacciones.length) {
      showAlert({
        message: "Agrega al menos una refacción antes de solicitar.",
        severity: "warning"
      })
      setLoadingB(false)
      return
    }

    let body = {
      productos: refacciones.map(({ idProducto, cantidad }) => ({
        idProducto,
        cantidad
      })),
      idOrdenServicio: id
    }

    let res = await Servo.post(
      "inventario-ordenes/solicitar",
      body,
      "ordenServicios",
      false,
      history
    )

    if (res?.cuerpo?.detalle?.estatus !== 200) {
      showAlert({
        message: res?.cuerpo?.mensaje || "Error al guardar refacción",
        severity: "error"
      })
      setLoadingB(false)
      return
    }

    setMessages(res.cuerpo)

    if (reloadRefacciones) {
      await reloadRefacciones()
    }
    await cargarSolicitudes()

    setRefacciones([])
    setLoadingB(false)
  }

  const detallesSolicitados = solicitudes.flatMap((solicitud) =>
    (solicitud.detalles || []).map((detalle) => ({
      ...detalle,
      idSolicitudRefaccion: solicitud.idSolicitudRefaccion,
      estadoSolicitud: solicitud.estado
    }))
  )

  const claveOperacion = () =>
    window.crypto?.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(36).slice(2)}`

  const abrirEntrega = (detalle) => {
    if (!sucursal) {
      showAlert({ message: "Selecciona el almacén", severity: "warning" })
      return
    }
    const limite = Number(
      detalle.cantidadAutorizada || detalle.cantidadSolicitada || 0
    )
    const cubierto =
      Number(detalle.cantidadEntregada || 0) +
      Number(detalle.cantidadCompraDirecta || 0)
    const restante = limite - cubierto
    if (restante <= 0) return
    setEntregaModal({
      open: true,
      detalle,
      cantidad: String(restante)
    })
  }

  const enviarAOrdenCompra = (detalle) => {
    const limite = Number(
      detalle.cantidadAutorizada || detalle.cantidadSolicitada || 0
    )
    const cubierto =
      Number(detalle.cantidadEntregada || 0) +
      Number(detalle.cantidadCompraDirecta || 0)
    const restante = limite - cubierto
    if (restante <= 0) return

    const idProducto = Number(
      detalle.idProductoAutorizado || detalle.idProductoSolicitado
    )
    const precioPublico = Number(
      detalle.precioPublicoAutorizado ||
        detalle.precioPublicoSolicitado ||
        0
    )
    const productoCompra = {
      idProducto,
      nombreProducto: detalle.autorizado || detalle.solicitado,
      numParte:
        detalle.numParteAutorizado || detalle.numParteSolicitado || "",
      precioPublico
    }
    const nuevoProducto = {
      producto: productoCompra,
      idProducto,
      categoria:
        detalle.categoriaAutorizada ||
        detalle.categoriaSolicitada ||
        "OTROS",
      precioPublico,
      precio: precioPublico,
      subtotal: precioPublico * restante,
      idProveedor: null,
      proveedor: null,
      cantidad: restante,
      idSolicitudRefaccionDetalle: detalle.idSolicitudRefaccionDetalle
    }

    setProductosOrdenCompra((actuales = []) => {
      const index = actuales.findIndex(
        (item) =>
          Number(item.idSolicitudRefaccionDetalle) ===
          Number(detalle.idSolicitudRefaccionDetalle)
      )
      if (index < 0) return [...actuales, nuevoProducto]
      return actuales.map((item, posicion) =>
        posicion === index ? { ...item, ...nuevoProducto } : item
      )
    })
    showAlert({
      message: `${productoCompra.nombreProducto} se agregó a Orden de Compra`,
      severity: "success"
    })
    if (irAOrdenCompra) irAOrdenCompra()
  }

  const cerrarEntrega = () => {
    if (loadingB) return
    setEntregaModal((prev) => ({ ...prev, open: false }))
  }

  const confirmarEntrega = async () => {
    const detalle = entregaModal.detalle
    if (!detalle || !sucursal) return
    const limite = Number(detalle.cantidadAutorizada || detalle.cantidadSolicitada || 0)
    const cubierto = Number(detalle.cantidadEntregada || 0) + Number(detalle.cantidadCompraDirecta || 0)
    const restante = limite - cubierto
    const cantidad = Number(entregaModal.cantidad)
    if (!cantidad || cantidad <= 0 || cantidad > restante) {
      showAlert({ message: `Ingresa una cantidad entre 1 y ${restante}`, severity: "warning" })
      return
    }
    const productoEntrega = {
      idSolicitudRefaccionDetalle: detalle.idSolicitudRefaccionDetalle,
      cantidad
    }
    setLoadingB(true)
    try {
      const res = await Servo.post(
        "inventario-ordenes/entregar",
        {
          idSolicitudRefaccion: detalle.idSolicitudRefaccion,
          idSucursal: sucursal.idSucursal,
          claveIdempotencia: claveOperacion(),
          productos: [productoEntrega]
        },
        "inventarios",
        false,
        history
      )
      if (res?.cuerpo) setMessages(res.cuerpo)
      if (res?.cuerpo?.detalle?.estatus === 200) {
        setEntregaModal((prev) => ({ ...prev, open: false }))
        await cargarSolicitudes()
      }
    } catch (error) {
      showAlert({
        message: "No fue posible confirmar la entrega. Actualiza la pantalla antes de volver a intentarlo.",
        severity: "error"
      })
    } finally {
      setLoadingB(false)
    }
  }

  const eliminarDetalle = async (detalle) => {
    setLoadingB(true)
    const res = await Servo.post(
      "inventario-ordenes/eliminar-detalle",
      { idSolicitudRefaccionDetalle: detalle.idSolicitudRefaccionDetalle },
      "ordenServicios",
      false,
      history
    )
    if (res?.cuerpo) setMessages(res.cuerpo)
    if (res?.cuerpo?.detalle?.estatus === 200) await cargarSolicitudes()
    setLoadingB(false)
  }

  const devolverEntrega = async (entregaDetalle) => {
    const cantidad = Number(
      window.prompt("Cantidad que regresa al almacén:", "1")
    )
    if (!cantidad || cantidad <= 0) return
    const motivo = window.prompt("Motivo de la devolución:", "No se utilizó")
    if (!motivo) return
    const res = await Servo.post(
      "inventario-ordenes/devolver",
      {
        idEntregaRefaccionDetalle:
          entregaDetalle.idEntregaRefaccionDetalle,
        cantidad,
        motivo,
        claveIdempotencia: claveOperacion()
      },
      "inventarios"
    )
    if (res?.cuerpo) setMessages(res.cuerpo)
    await cargarSolicitudes()
  }

  const entregasAlmacen = solicitudes
    .flatMap((solicitud) => solicitud.entregas || [])
    .filter((entrega) => entrega.tipo === "ALMACEN")
    .flatMap((entrega) => entrega.detalles || [])

  const progresoDetalle = (detalle) => {
    const solicitado = Number(detalle.cantidadAutorizada || detalle.cantidadSolicitada || 0)
    const entregado = Number(detalle.cantidadEntregada || 0) + Number(detalle.cantidadCompraDirecta || 0)
    return { solicitado, entregado, porcentaje: solicitado > 0 ? Math.min(100, (entregado / solicitado) * 100) : 0 }
  }

  return (
    <section className="parts-request" aria-labelledby="parts-request-title">
      <div className="parts-request__panel parts-request__composer">
        <header className="parts-request__header">
          <div>
            <h2 id="parts-request-title">Levantamiento de refacciones</h2>
            <p>Indica las piezas y cantidades necesarias para realizar el trabajo.</p>
          </div>
          <span className="parts-request__count">{refacciones.length} {refacciones.length === 1 ? "pieza" : "piezas"}</span>
        </header>

        <div className="parts-request__selectors">
          <Input
            typeInput="formSelect"
            valor={categoriaSeleccionada}
            nombre="Categoría"
            onChange={handleCategoriaChange}
            data={[
              { label: "Selecciona una categoría", value: "" },
              { label: "SUSPENSIÓN", value: "SUSPENSION" },
              { label: "SERVICIO MOTOR", value: "SERVICIO MOTOR" },
              { label: "DIFERENCIAL", value: "DIFERENCIAL" },
              { label: "FRENOS", value: "FRENOS" },
              { label: "NEUMÁTICOS", value: "NEUMATICOS" },
              { label: "INTERIORES", value: "INTERIORES" },
              { label: "REFACCIONES ELÉCTRICAS", value: "REFACCIONES ELECTRICAS" },
              { label: "ADITAMENTOS", value: "ADITAMENTOS" },
              { label: "TRANSMISIÓN", value: "TRANSMISION" },
              { label: "OTROS", value: "OTROS" }
            ]}
          />
          <div className="parts-request__product">
            {categoriaSeleccionada ? (
              <AutocompleteDeluxe
                labelToShow="Refacción o material"
                labelProp="nombreProducto"
                idProp="idProducto"
                concat="numParte"
                nombre="productos"
                dato={producto}
                setDato={setProducto}
                filtro={{ expand: "inventario", categoria: categoriaSeleccionada }}
                background="#F2F2F2"
                key={categoriaSeleccionada}
              />
            ) : (
              <div className="parts-request__product-placeholder">
                <span>Refacción o material</span>
                <p>Primero selecciona una categoría</p>
              </div>
            )}
          </div>
          <Button variant="contained" startIcon={<AddIcon />} disabled={!producto || loadingB} onClick={addProducto}>
            Agregar
          </Button>
        </div>
      </div>

      <div className="parts-request__columns">
        <article className="parts-request__panel parts-request__draft">
          <header className="parts-request__section-heading">
            <div><h3>Solicitud por enviar</h3><p>Ajusta las cantidades antes de enviarla a almacén.</p></div>
          </header>
          {refacciones.length ? (
            <ul className="parts-request__draft-list">
              {refacciones.map((element, index) => (
                <li key={element.idProducto}>
                  <div className="parts-request__item-number">{index + 1}</div>
                  <div className="parts-request__item-info">
                    <strong>{element.nombreProducto}</strong>
                    <span>{element.numParte || "Sin número de parte"}</span>
                  </div>
                  <div className="parts-request__quantity" aria-label={`Cantidad de ${element.nombreProducto}`}>
                    <IconButton aria-label="Disminuir cantidad" disabled={element.cantidad <= 1 || loadingB} onClick={() => changeCantidad(element.cantidad - 1, index)}><RemoveIcon /></IconButton>
                    <span>{element.cantidad}</span>
                    <IconButton aria-label="Aumentar cantidad" disabled={loadingB} onClick={() => changeCantidad(element.cantidad + 1, index)}><AddIcon /></IconButton>
                  </div>
                  <Tooltip title="Quitar de la solicitud"><span><IconButton className="parts-request__delete" aria-label={`Quitar ${element.nombreProducto}`} disabled={loadingB} onClick={() => deleteProduct(element.idProducto)}><DeleteOutlineIcon /></IconButton></span></Tooltip>
                </li>
              ))}
            </ul>
          ) : (
            <div className="parts-request__empty"><strong>La solicitud está vacía</strong><span>Selecciona una categoría y agrega las piezas que vas a necesitar.</span></div>
          )}
          <div className="parts-request__submit">
            <LoadingButton variant="contained" loading={loadingB} disabled={!refacciones.length || refacciones.some((item) => !Number(item.cantidad))} onClick={guardarRefaccionesOrdenServicio}>
              Enviar solicitud
            </LoadingButton>
          </div>
        </article>

        <article className="parts-request__panel parts-request__tracking">
          <header className="parts-request__section-heading">
            <div><h3>Solicitudes y entregas</h3><p>Consulta lo solicitado y cuánto se ha recibido.</p></div>
            <span>{detallesSolicitados.length}</span>
          </header>
          {puedeAlmacen && (
            <div className="parts-request__warehouse">
              <div>
                <AutocompleteDeluxe
                  labelToShow="Almacén físico"
                  labelProp="nombreSucursal"
                  idProp="idSucursal"
                  nombre="sucursales"
                  dato={sucursal}
                  setDato={setSucursal}
                  background="#F2F2F2"
                />
              </div>
              <div className="parts-request__responsible">
                <span>Empresa responsable de la orden</span>
                <strong>{empresa?.nombre || "Sin empresa asignada"}</strong>
              </div>
              <small>Selecciona el almacén del que saldrán físicamente las refacciones.</small>
            </div>
          )}
          {detallesSolicitados.length ? (
            <ul className="parts-request__tracking-list">
              {detallesSolicitados.map((detalle) => {
                const progreso = progresoDetalle(detalle)
                const surtida = detalle.estadoSolicitud === "SURTIDA" || progreso.porcentaje >= 100
                const devoluciones = entregasAlmacen.filter((entrega) => Number(entrega.idSolicitudRefaccionDetalle) === Number(detalle.idSolicitudRefaccionDetalle))
                return (
                  <li key={detalle.idSolicitudRefaccionDetalle}>
                    <div className="parts-request__tracking-top">
                      <div className="parts-request__item-info">
                        <strong>{detalle.autorizado || detalle.solicitado}</strong>
                        <span>{detalle.numParteAutorizado || detalle.numParteSolicitado || "Sin número de parte"}</span>
                      </div>
                      <span className={`parts-request__status ${surtida ? "parts-request__status--done" : ""}`}>{surtida ? "Completa" : detalle.estadoSolicitud || "Pendiente"}</span>
                    </div>
                    <div className="parts-request__progress-label"><span>Entregado</span><strong>{progreso.entregado} de {progreso.solicitado}</strong></div>
                    <div className="parts-request__progress"><span style={{ width: `${progreso.porcentaje}%` }} /></div>
                    <div className="parts-request__admin-actions">
                        {puedeAlmacen && <Button variant="outlined" disabled={loadingB || surtida} onClick={() => abrirEntrega(detalle)}>Entregar</Button>}
                        {puedeAlmacen && <Button variant="outlined" disabled={loadingB || surtida} onClick={() => enviarAOrdenCompra(detalle)}>Compra directa</Button>}
                        {puedeAlmacen && devoluciones.map((entrega) => <Button key={entrega.idEntregaRefaccionDetalle} variant="text" color="warning" disabled={loadingB} onClick={() => devolverEntrega(entrega)}>Devolver</Button>)}
                        {!puedeAlmacen && <p className="parts-request__waiting">Almacén atenderá esta solicitud.</p>}
                        <Tooltip title={progreso.entregado > 0 ? "No se puede eliminar porque ya tiene entregas" : "Eliminar de la solicitud"}>
                          <span className="parts-request__remove-request">
                            <IconButton
                              aria-label={`Eliminar ${detalle.autorizado || detalle.solicitado} de la solicitud`}
                              disabled={loadingB || progreso.entregado > 0}
                              onClick={() => eliminarDetalle(detalle)}
                            >
                              ×
                            </IconButton>
                          </span>
                        </Tooltip>
                    </div>
                  </li>
                )
              })}
            </ul>
          ) : (
            <div className="parts-request__empty"><strong>Sin solicitudes enviadas</strong><span>Cuando envíes una solicitud podrás consultar aquí sus entregas.</span></div>
          )}
        </article>
      </div>

      <Dialog
        open={entregaModal.open}
        onClose={cerrarEntrega}
        fullWidth
        maxWidth="xs"
        PaperProps={{ className: "parts-delivery-dialog" }}
      >
        <DialogTitle>Entregar refacción</DialogTitle>
        <DialogContent>
          <p className="parts-delivery-dialog__product">
            {entregaModal.detalle?.autorizado || entregaModal.detalle?.solicitado}
          </p>
          <TextField
            autoFocus
            fullWidth
            type="number"
            label="Cantidad a entregar"
            value={entregaModal.cantidad}
            inputProps={{ min: 1, step: 1 }}
            onChange={(event) => setEntregaModal((prev) => ({ ...prev, cantidad: event.target.value }))}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={cerrarEntrega} disabled={loadingB}>Cancelar</Button>
          <LoadingButton variant="contained" loading={loadingB} onClick={confirmarEntrega}>Confirmar entrega</LoadingButton>
        </DialogActions>
      </Dialog>
    </section>
  )
}

export default Refacciones
